import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';

export default function DynamicSwitch(props) {
    const {
        disabled = false,
        value = false,
        labels = ['Off', 'On'],
        offColor = 'secondary.main',
        onColor = 'primary.main',
        onChange = () => null,
        typohraphyClassNames = "",
    } = props;

    // const switchThumbColor = value ? onColor : offColor;

    return (
        <Stack direction="row" alignItems="center" className="pr-2">
            <Typography
                className={`fw-bold ${typohraphyClassNames}`}
                color={value ? onColor : offColor}
                variant="subtitle1"
                sx={{ fontSize: { xs: 7, md: 10 } }}
            >
                {labels[0]}
            </Typography>
            <Switch
                disabled={disabled}
                checked={value}
                onChange={onChange}
                sx={{
                    ...(disabled ? {
                        cursor: 'not-allowed',
                        '& .MuiSwitch-thumb': {
                            backgroundColor: '#beacac',
                        },
                        '& .MuiSwitch-track': {
                            backgroundColor: '#d5c4c4',
                            opacity: 1,
                        },
                    } : {
                        '& .MuiSwitch-thumb': {
                            backgroundColor: offColor,
                        },
                      
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            // backgroundColor: offColor,
                            // opacity: 1,
                            backgroundColor: '#000',
                            opacity: '0.38'
                        },
                    }),
                }}
            />
            <Typography
                className={`fw-bold ${typohraphyClassNames}`}
                color={value ? offColor : onColor}
                variant="subtitle1"
                sx={{ fontSize: { xs: 7, md: 10 } }}
            >
                {labels[1]}
            </Typography>
        </Stack>
    );
}
